// 네비게이션 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역

// =================================================================================================
// 상수
// =================================================================================================
// 화면으로 이동 (싱글톤)
const goToScreen = (
  currentScreenProps, // 현재 화면 속성
  screenId, // 화면 아이디
  params // 인자
) => {
  let navigation = currentScreenProps.navigation;
  navigation.navigate(screenId, params);
};

// 화면 쌓기 (중복 생성 가능)
const pushScreenOnStack = (
  currentScreenProps, // 현재 화면 속성
  screenId, // 화면 아이디
  params // 인자
) => {
  let navigation = currentScreenProps.navigation;
  navigation.push(screenId, params);
};

// 뒤로가기
const goBackScreen = (
  currentScreenProps // 현재 화면 속성
) => {
  let navigation = currentScreenProps.navigation;
  navigation.goBack();
};

// 화면 이동하며 전달받은 인자 겟
const getRouteParams = (
  currentScreenProps // 현재 화면 속성
) => {
  let route = currentScreenProps.route;
  return route.params;
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  getRouteParams,
  goBackScreen,
  goToScreen,
  pushScreenOnStack,
};
